export const parseYouTubeId = (url) => {
  if (!url) return "";
  const m = String(url).match(/(?:youtube\.com\/(?:watch\?[^#]*v=|embed\/|shorts\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/);
  if (m) return m[1];
  const t = String(url).trim();
  return /^[A-Za-z0-9_-]{11}$/.test(t) ? t : "";
};

export const youtubeThumb = (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`;

export const youtubeEmbed = (id) => `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&rel=0`;
